module.exports = __webpack_public_path__ + "static/apple-icon-72x72-924285624c6c08301a9d892db04f3e7d.png";